import { dashboardConstants } from "../../constants/client";

const initialState = {};

export default function dashboard(state = initialState, action) {
  let oldstate = state;
  let currentstate = false;

  switch (action.type) {
    case dashboardConstants.LISTING_REQUEST:
      currentstate = {
        //paginationOptions: null,
        //list: null,
        //total_active_sensor: null,
        //total_in_active_sensor: null,
        //error: null,
        update_required: null,
        //details: null,
        loading: true,
      };
      break;
    case dashboardConstants.LISTING_SUCCESS:
      currentstate = {
        list: action.payload.list,
        total_active_sensor: action.payload.total_active_sensor,
        total_in_active_sensor: action.payload.total_in_active_sensor,
        total_virtual_sensor: action.payload.total_virtual_sensor,
        //paginationOptions: action.payload.paginationOptions,
        loading: false,
      };
      break;
    case dashboardConstants.LISTING_FAILURE:
      currentstate = { error: action.payload, loading: false };
      break;

    default:
      break;
  }

  if (!!currentstate) {
    return { ...oldstate, ...currentstate };
  } else {
    return oldstate;
  }
}
